import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./search.css";
import Spinner from "../Loader/loading";

const Search = ({ query, setQuery, handleSearch }) => {
    const navigate = useNavigate();
    const [searchType, setSearchType] = useState("decisions");
    const [loading, setLoading] = useState(false);
    const [enterPressed, setEnterPressed] = useState(false);
    const [error, setError] = useState("");

    const handleSearchs = (e) => {
        e.preventDefault();

        if (!query || query.trim() === "") {
            if (searchType === "texte_loi") {
                navigate("/Loisresult");
                return;
            } else {
                setError("Veuillez entrer un terme de recherche");
            }
            return;
        }

        setError("");
        setEnterPressed(true);

        if (searchType === "decisions") {
            console.log(`Searching for: ${query} in category: decisions`);
            handleSearch();
            navigate(`/allresult?query=${encodeURIComponent(query)}`);
        } else {
            console.log(`Searching for: ${query} in category: texte_loi`);
            navigate(`/Loisresult?query=${encodeURIComponent(query)}`);
        }
    };

    useEffect(() => {
        setEnterPressed(false);
        setError("");
    }, [query]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearchs(e);
        }
    };

    const handleAdvancedSearch = () => {
        if (searchType === "decisions") {
            navigate(`/allresult?query=${encodeURIComponent("2023")}`);
        } else {
            navigate("/Loisresult");
        }
    };

    return (
        <div className="searchbare">
            {/* Barre de recherche */}
            <form onSubmit={handleSearchs} className="searchbare-input-container">
                <input
                    type="text"
                    placeholder="Recherchez une décision de justice ou un texte de loi..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={handleKeyDown}
                    className={`searchbare-input ${error ? "error-input" : ""}`}
                    autoFocus
                />
                <select
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                    className="searchbare-select"
                >
                    <option value="decisions">Décisions</option>
                    <option value="texte_loi">Texte de loi</option>
                </select>
                <button type="submit" className="searchbare-button">
                    Rechercher
                </button>
            </form>

            {error && (
                <div className="error-message">
                    {error}
                </div>
            )}

            <button
                className="searchbare-advanced"
                onClick={handleAdvancedSearch}
            >
                Recherche avancée
            </button>

            {loading && (
                <div className="loading-container">
                    <Spinner />
                </div>
            )}
        </div>
    );
};

export default Search;